import { CircleAlert } from 'lucide-react';
import { Link } from 'react-router-dom';

import { GatewayActions, GatewayBrand, GatewayContent, GatewayShell } from '@/_shared/components/GatewayShell';
import { Button } from '@/_shared/components/ui/button';

/** An emailed link opened without its token, for example after a reload dropped it from the URL. */
export function LinkNotValid({ actionLabel, actionTo }: { actionLabel: string; actionTo: string }): React.ReactElement {
  return (
    <GatewayShell>
      <GatewayBrand poweredBy />
      <GatewayContent
        icon={<CircleAlert />}
        variant="warning"
        title="This link is not valid"
        description="Open the link in your email again, or start over."
      />
      <GatewayActions>
        <Button variant="primary" size="lg" className="w-full" asChild>
          <Link to={actionTo}>{actionLabel}</Link>
        </Button>
      </GatewayActions>
    </GatewayShell>
  );
}
